import React from 'react';
import { observer, Observer, inject } from 'mobx-react';
import { toJS, action } from 'mobx';
import moment from 'moment';

import { SiteHeader } from '../component/SiteHeader';
import { SiteFooter } from '../component/SiteFooter';
import { PreventParentScroll } from '../component/PreventParentScroll';
import { Focuspoint } from '../component/Focuspoint';
import { Dropdown } from '../component/Dropdown';
import { DayPicker } from '../component/DayPicker';

import { fmtPrice, fmtPercent, fmtDatetime, fmtDate, fmtTime } from '../../model/formatters';
import { getIn, replaceBetween } from '../../utils';
import translateBase from '../../translate';
let translate = translateBase.bindPage('home');

function claimImgSrc() {
  return getIn(window, ['ict', 'wyby', 'orgClaimImage']);
}

@inject(stores => ({
  navigation: stores.app.navigation,
  vHome: stores.app.vHome,
  searchForm: stores.app.searchForm,
  organization: stores.app.organization,
}))
@observer
export class Home extends React.Component {
  render() {
    const { organization, searchForm, navigation, vHome, businessUnit } = this.props;
    const searchFieldCount = 2 + (searchForm.showLocation ? 1 : 0) + (searchForm.showCategory ? 1 : 0);
    let searchFieldsClass = '';
    switch (searchFieldCount) {
      case 2:
        searchFieldsClass = ' two';
        break;
      case 3:
        searchFieldsClass = ' three';
        break;
      case 4:
        searchFieldsClass = ' four';
        break;
    }
    return (
      <div>
        <SiteHeader />

        <section className="mainimg-container">
          <div className="wrapper claim-container">
            <div className="row">
              <div className="column-5 claim">
                <h1 className="mali-blue">{organization.name}</h1>
                <h3>{organization.claim}</h3>
              </div>
            </div>
          </div>
          <div className="row img-container">
            <div className="column-7 offset-5">
              <Focuspoint
                src={claimImgSrc()}
                imageW={1600}
                imageH={961}
                focusX={0.0}
                focusY={0.0}
                reCalcOnWindowResize={true}
              />
            </div>
          </div>
        </section>

        <section className={"searchbar-container" + searchFieldsClass}>
          <div className="wrapper">
            <div className="row">
              <div className="column-12">

                <div className="search-container">


                  {/* ========== LOCATION ========== */}
                  {searchForm.showLocation && <Dropdown>{({ ref, isOpen, onOpen, onClose, onOpenToggle }) => <Observer>{() =>
                    <div ref={ref} className="search-content" onClick={onOpenToggle}>
                      <div className="label small">{translate("location", "Standort")}</div>
                      <div className="input big">{searchForm.locationText || translate("allLocationsSelected", "All locations")}</div>

                      {<PreventParentScroll>{({ refScrollable, onScrollableWheel }) => <Observer>{() =>
                        <div className={"dropdown list" + (isOpen ? ' active' : '')} ref={refScrollable} onWheel={onScrollableWheel} onClick={event => event.stopPropagation()}>
                          {searchForm.optLocation ?
                            <ul>
                              <li>
                                <a onClick={() => {
                                  searchForm.location = undefined;
                                  onClose();
                                }}>{translate("selectAllLocations", "All locations")}</a>
                              </li>
                              {searchForm.optLocation.map(option =>
                                <li key={option.value}>
                                  <a onClick={() => {
                                    searchForm.location = option.value;
                                    onClose();
                                  }}
                                    data-value={option.value}>
                                    {option.text}
                                  </a>
                                </li>
                              )}
                            </ul>
                            :
                            <div className="no-items-available">{translate("noItemsLoadedYet", "No items loaded yet.")}</div>}
                        </div>
                      }</Observer>}</PreventParentScroll>}
                    </div>
                  }</Observer>}</Dropdown>}



                  {/* ========== CATEGORY ========== */}
                  {searchForm.showCategory && <Dropdown>{({ ref, isOpen, onOpen, onClose, onOpenToggle }) => <Observer>{() =>
                    <div ref={ref} className="search-content" onClick={onOpenToggle}>
                      <div className="label small">{translate("objectType", "Objekttyp")}</div>
                      <div className="input big">{
                        (!searchForm.categoryText || !searchForm.subcategoryText) ?
                          translate("allCategoriesSelected", "All categories") :
                          <span>{searchForm.categoryText} / {searchForm.subcategoryText}</span>
                      }</div>
                      {<PreventParentScroll>{({ refScrollable, onScrollableWheel }) => <Observer>{() =>
                        <div className={"dropdown list" + (isOpen ? ' active' : '')} ref={refScrollable} onWheel={onScrollableWheel} onClick={event => event.stopPropagation()}>
                          {searchForm.optCategory ?
                            <ul>
                              <li>
                                <a onClick={action(() => {
                                  searchForm.category = undefined;
                                  searchForm.subcategory = undefined;
                                  onClose();
                                })} >
                                  {translate("selectAllCategories", "All categories.")}
                                </a>
                              </li>
                              {searchForm.optCategory.map(category =>
                                <li><b>{category.text}</b>
                                  <ul>
                                    {searchForm.optSubcategory(category.value).map(subcategory =>
                                      <li><a
                                        onClick={action(() => {
                                          searchForm.category = category.value;
                                          searchForm.subcategory = subcategory.value;
                                          onClose();
                                        })}
                                        data-value={subcategory.value}>
                                        {subcategory.text}
                                      </a></li>
                                    )}
                                  </ul>
                                </li>
                              )}
                            </ul>
                            :
                            <div className="no-items-available">{translate("noItemsLoadedYet", "No items loaded yet.")}</div>
                          }
                        </div>
                      }</Observer>}</PreventParentScroll>}
                    </div>
                  }</Observer>}</Dropdown>}


                  {/* ========== START DATE ========== */}
                  <Dropdown>{({ ref, isOpen, onOpen, onClose, onOpenToggle }) => <Observer>{() =>
                    <div ref={ref} className="search-content" onClick={onOpenToggle}>
                      <div className="label small">{translate("startDate", "Start Datum *")}</div>
                      <div className="input big">{searchForm.startDate ?
                        fmtDate(searchForm.startDate) : translate("noStartDateSelected", "Kein Start Datum gewählt")}</div>
                      {<div className={"dropdown calendar" + (isOpen ? ' active' : '')} onClick={event => event.stopPropagation()}>
                        <DayPicker
                          disableBefore={moment()}
                          onDayClick={(day) => {
                            var newStart = moment(day);
                            var ssStart = window.sessionStorage.getItem('searchStartDate');
                            if (ssStart) {
                              var currentStart = moment(ssStart);
                              newStart.set({
                                hour: currentStart.get('hour'),
                                minute: currentStart.get('minute'),
                                second: currentStart.get('second')
                              });
                            }
                            let newStartZ = moment(newStart).utc().format("YYYY-MM-DDTHH:mm:00.000") + "Z";
                            searchForm.startDate = newStartZ;
                            onClose();
                          }}
                          selectedDays={new Date(searchForm.startDate)}
                        />
                      </div>}
                    </div>
                  }</Observer>}</Dropdown>


                  {/* ========== TIME SPAN ========== */}
                  <Dropdown>{({ ref, isOpen, onOpen, onClose, onOpenToggle }) => <Observer>{() =>
                    <div ref={ref} className="search-content" onClick={onOpenToggle}>
                      <div className="label small">{translate("duration", "Dauer *")}</div>
                      <div className="input big">{searchForm.duration}{" "}{searchForm.timeUnitText}{" "}
                        {searchForm.endDate && <span>({translate("to", "to")}{" "}{fmtDate(searchForm.endDate)})</span>}
                      </div>
                      {<div className={"dropdown duration" + (isOpen ? ' active' : '')} onClick={event => event.stopPropagation()}>
                        <div className="row">
                          <div className="label">
                            {translate("count", "Anzahl")}
                          </div>
                          <div className="input">
                            <input placeholder={translate("enterUnitsCount", "Enter units count")} value={searchForm.duration} />
                            <a className={"minus" + (searchForm.canDecDuration ? "" : " unselectable")} onClick={searchForm.decDuration}><i className="fa fa-minus"></i></a>
                            <a className={"plus" + (searchForm.canIncDuration ? "" : " unselectable")} onClick={searchForm.incDuration}><i className="fa fa-plus"></i></a>
                          </div>
                        </div>
                        <div className="row">
                          <div className="label">
                            {translate("timeUnit", "Zeiteinheit")}
                          </div>
                          <div className="input">
                            <input placeholder={translate("enterUnitsType", "Enter units type")} value={searchForm.timeUnitText} />
                            <a className={"minus" + (searchForm.canDecTimeUnit ? "" : " unselectable")} onClick={searchForm.decTimeUnit}><i className="fa fa-minus"></i></a>
                            <a className={"plus" + (searchForm.canIncTimeUnit ? "" : " unselectable")} onClick={searchForm.incTimeUnit}><i className="fa fa-plus"></i></a>
                          </div>
                        </div>
                      </div>}
                    </div>
                  }</Observer>}</Dropdown>

                  <a id="btn-search" className={"search-btn" + (searchForm.isSearchAllowed ? "" : " disabled")} onClick={searchForm.isSearchAllowed && navigation.goSearch} >
                    {translate("search", "Suchen")} <i className="fa fa-search" aria-hidden="true"></i>
                  </a>
                </div>

              </div>
            </div>
          </div>
        </section>

        {organization.isShowingTeasers && <section className="teasers-container home-page">
          <div className="wrapper">
            <div className="row">
              {vHome.randomObjects.map(object =>
                <div className="column-4" key={object.id}>
                  <a className="product-container" href={navigation.hrefObjectDetails(object.id)}>
                    <figure className="product-image">
                      <div className="spacer"></div>
                      <Focuspoint
                        src={object.thumbnailUrl}
                        imageW={756}
                        imageH={415}
                        focusX={0.0}
                        focusY={0.0}
                        reCalcOnWindowResize={true}
                      />
                    </figure>
                    <div className="product-details">
                      <div className="product-name biggest">
                        {object.name}
                      </div>
                      {(object.resultPriceFrom !== null) && <div className="product-price">
                        <span className="from">{translate("priceFrom", "Ab")}</span>
                        <span className="amount">{object.currencyName} {fmtPrice(object.resultPriceFrom)}</span>
                        <span className="duration">/ {object.timeUnitForPrice}</span>
                      </div>}
                      <div className="product-location">
                        <i className="fa fa-map-marker" aria-hidden="true"></i> {object.businessUnitName}
                      </div>
                    </div>
                  </a>
                </div>
              )}
            </div>
          </div>
        </section>}

        <SiteFooter />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/visual/view/Home.js